var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, KompisElement, property } from '@inter-ikea-kompis/web-component';
import { registerIcon, warningTriangle } from '@ingka/icon-store';
import { Icon as SkapaIcon } from '@ingka/icon-webc/passive.js';
import { InlineMessage as SkapaInlineMessage } from '@ingka/inline-message-webc/passive.js';
/**
 * Internal component to show the "Injury or Death" version of the tipover warning.
 *
 * @event click Triggered when button is clicked.
 */
export default class InjuryOrDeathWarning extends KompisElement {
    async connectedCallback() {
        registerIcon(warningTriangle);
        this.customElements.define('skapa-inline-message', SkapaInlineMessage);
        this.customElements.define('skapa-icon', SkapaIcon);
        super.connectedCallback();
    }
    render() {
        const { injuryOrDeathWarningTitle, injuryOrDeathWarningBody } = this.translations;
        return html `
			<skapa-inline-message variant="cautionary">
				<skapa-icon slot="message-icon" icon="warning-triangle"></skapa-icon>
				<span slot="title">${injuryOrDeathWarningTitle}</span>
				<span slot="body">${injuryOrDeathWarningBody}</span>
			</skapa-inline-message>
		`;
    }
}
__decorate([
    property({ type: Object })
], InjuryOrDeathWarning.prototype, "translations", void 0);
//# sourceMappingURL=InjuryOrDeathWarning.js.map